import { render, staticRenderFns } from "./FichaContenido.vue?vue&type=template&id=78d7a09a&"
import script from "./FichaContenido.vue?vue&type=script&lang=js&"
export * from "./FichaContenido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports